import ChildParentContribution from '../dto/ChildParentContribution';
import Error from '../model/Error';
import axios from 'axios';

export default class ChildParentContributionRepository {

    static createPdf(childId, childParentIncomeId, text) {
        return new Promise((resolve, reject) => {
            axios
                .post('/' + childId + '/child-parent-contribution/' + childParentIncomeId + '/createPdf', {
                    content: text
                })
                .then(response => resolve(response.headers['location']))
                .catch(error => reject(Error.fromResponse(error.response)));
        })
    }

    static get(childId, childParentIncomeId) {
        return new Promise((resolve, reject) => {
            axios
                .get('/' + childId + '/child-parent-contribution/' + childParentIncomeId)
                .then(response => resolve(response.data.data.map(data => ChildParentContribution.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        })
    }
}
